import {Component, OnInit} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {startOfDay} from 'date-fns';
import {CommonModule} from '@angular/common';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {ReactiveFormsModule} from '@angular/forms';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';

@Component({
  selector: 'formly-field-nz-datetime-picker',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzDatePickerModule,
  ],
  template: `
      <nz-date-picker style="width: 100%;"
                      [nzShowTime]="{nzFormat: 'HH:mm', nzMinuteStep: 30, nzDefaultOpenValue: defaultValue}"
                      nzFormat="yyyy-MM-dd HH:mm"
                      [formControl]="$any(formControl)"></nz-date-picker>
  `,
})
export class ZorrlyDateTimeComponent extends FieldType implements OnInit {

  defaultValue = startOfDay(new Date());

  ngOnInit(): void {
    const val = this.formControl.value;
    if (val && !!val.seconds) {
      this.formControl.patchValue(new Date(val.seconds * 1000), {emitEvent: false});
    }
  }


}
